
<div class="login-container">
    <div class="login-content">
      <div class="logo-section">
        <h1 class="app-title">Dispatch Application</h1>
      </div>
      
      <div class="card login-card">
        <div class="card-content">
          <h2>Sign In</h2>
          
          <!-- Error message -->
          <div *ngIf="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
          </div>
          
          <!-- Session expired notification -->
          <div *ngIf="sessionExpired" class="session-expired">
            <p>Your session has expired. Please sign in again.</p>
          </div>
          
          <!-- Loading spinner -->
          <div *ngIf="loginInProgress" class="loading-spinner">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="4"></p-progressSpinner>
            <p>Signing in...</p>
          </div>
          
          <!-- Login button -->
          <div *ngIf="!loginInProgress" class="login-actions">
            <button pButton label="Sign in with Microsoft" icon="pi pi-microsoft" (click)="login()" class="p-button-primary"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  